











































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import Endpoint from "@/utils/endpoint";
import CustomerService from "@/services/customerService";
import AccountInterface, { accountInitialValue } from "@/types/app/accounts";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";
import NewInterface, { newInitialValue } from "@/types/app/news";
import NewService from "@/services/newService";
import { VueEditor } from "vue2-editor";

const namespace = "account";

@Component({
  components: { VueEditor },
})
export default class NewsForm extends BaseComponent {
 
  private endpoint = new Endpoint();
  customToolbar = [
    [{ font: [] }],
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
    [{ header: 1 }, { header: 2 }],
    ["blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    ["clean"],
  ];
  fromDateMenu = false;

  modelNew: NewInterface = newInitialValue;
  customerService = new CustomerService(this.$http);
  private newService = new NewService(this.$http);
  accounts: AccountInterface[] = [];
  formatDate = formatDate;
  formatMoney = formatMoney;
  newLoading = false;
  preview: any = null;
  image: any = null;
  get isFormView(): boolean {
    return this.formType == 'view'
  }

  get isFormCreate(): boolean {
    return this.formType == 'add'
  }

  get isFormEdit(): boolean {
    return this.formType == 'edit'
  }

  get newId(): string {
    return this.$route.params.newId
  }

  get formType(): string {
    return this.$route.params.formType
  }

  async mounted() {
    this.newLoading = true;
    if (this.newId)
    {
      new Uint8Array(this.modelNew.imageContent)
      this.modelNew = await this.newService.getNewsById(this.newId);
      this.preview = `data:${this.modelNew.imageContentType};base64,` + this.modelNew.imageContent;
    }
      this.newLoading = false;

  }

  showEdit(): void {
    this.goTo();
  }
  limit=150;
  onTextChange(event:any) {
    console.log(event);
    // const quill = (this.$refs.editor as VueEditor).quill
    // const len = quill.getLength()
    // if (len > this.limit) {
    //   quill.deleteText(this.limit, len);
    // }
  }

  goTo() {
    this.$router.push({
      name: "NewsForm",
      params: {
        newId: this.modelNew.id,
        formType: 'edit',
      }
    });
  }

  previewImage(event: any) {
    const input = event.target;
    
    if (input.files) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.preview = e.target.result;
        //this.modelNew.file = this.preview;
      }
      this.image = input.files[0];
      reader.readAsDataURL(input.files[0]);
    }
  }

  async saveNews() {
    if (this.form().validate()) {


      this.newLoading = true;

      try {
        const formData = new FormData();
        formData.append("file", this.image);
        formData.append("title", this.modelNew.title);
        formData.append("description", this.modelNew.description);
        formData.append("imageTitle", this.modelNew.imageTitle);
        formData.append("dtNew", this.modelNew.dtNew);
        formData.append("link", this.modelNew.link);
        this.modelNew.file = this.image;
        const result = await this.newService.saveNews(
          formData, this.newId,
          this.formType == "edit"
        );
        if (!result.hasErrors) {
          this.showSuccess('Create news with successful!');       
          this.closeModal();
        }else  this.showError(result.messageErroDefault);
      } catch (error) {
        ErrorService.onError(error);
      } finally {
        this.newLoading = false;
      }
    }
  }

  closeModal(): void {
    this.clearFields();
    this.$router.push({name: "News"});
  }

 

  clearFields() {
    this.modelNew = newInitialValue;
    //this.form().reset();
  }

}
